var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTicketIconLightgray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.616 4.0212V6.83371M15.616 10.6239V13.4364M15.616 17.24V20.0525M1.55347 18.3382C1.55347 19.285 2.32099 20.0525 3.26775 20.0525H20.7321C21.6788 20.0525 22.4464 19.285 22.4464 18.3382V15.1844C21.0573 14.8079 20.0356 13.5383 20.0356 12.0301C20.0356 10.522 21.0573 9.2524 22.4464 8.87585V5.7221C22.4464 4.77533 21.6788 4.00781 20.7321 4.00781H3.26775C2.32099 4.00781 1.55347 4.77533 1.55347 5.7221V8.8687C2.95611 9.23611 3.99096 10.5123 3.99096 12.0301C3.99096 13.548 2.95611 14.8242 1.55347 15.1916V18.3382Z",
    stroke: "#D5D5D5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketIconLightgray);
export default __webpack_public_path__ + "static/media/ticket-icon-lightgray.dc95f53b.svg";
export { ForwardRef as ReactComponent };